<template>
    <div class="person-info webcrm-entity-info">
        <div class="header-panel">
            <div :class="['image', 'person', { 'empty': !value.PersonImageFileExtension }]" :style="imageStyle"></div>
            <div class="name-container">
                <div class="name">{{ value.PersonName }}</div>
                <div class="sub-name" v-if="showTitle">{{ value.PersonTitle }}</div>
            </div>
            <div class="more-options">
                <el-tooltip :content="$t('show_in_{0}', ['webCRM'])">
                    <div class="open-link" @click="open">open_in_new</div>
                </el-tooltip>
                <el-dropdown trigger="click" @command="selectPerson" v-if="showOtherPersons">
                    <el-tooltip :content="`${$t('other')} ${$t('terms.persons').toLowerCase()}`" placement="left">
                        <div class="open-link">expand_more</div>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="person in persons"
                                          :key="person.PersonId"
                                          :command="person"
                                          :disabled="person.PersonId == value.PersonId">
                            {{ person.PersonName }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="body-panel">
            <div class="info-item clickable" v-if="showEmail" @click="openEmail">
                <div class="md-icon">mail</div>
                <div class="item-text">{{ value.PersonEmail }}</div>
            </div>
            <div class="info-item clickable" v-if="showEmail2" @click="openEmai2l">
                <div class="md-icon">mail</div>
                <div class="item-text">{{ value.PersonEmail2 }}</div>
            </div>
            <div class="info-item clickable" v-if="showDirectPhone" @click="openDirectPhone">
                <div class="md-icon">call</div>
                <div class="item-text">{{ value.PersonDirectPhone }}</div>
            </div>
            <div class="info-item clickable" v-if="showMobilePhone" @click="openMobilePhone">
                <div class="md-icon">phone_iphone</div>
                <div class="item-text">{{ value.PersonMobilePhone }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue, { PropType } from 'vue';

    import tag from '@/controls/tag.vue';

    import { Person } from '@/utilities/api/persons';
    import { NavigationProvider } from '@/utilities/navigation';
    import { MetadataProvider } from '@/utilities/fields/metadata';
    import { FieldName } from '@/utilities/fields/names';

    export default Vue.extend({
        name: 'person-info',
        components: {
            tag
        },
        props: {
            value: Object as PropType<Person>,
            persons: Array as PropType<Person[]>,
        },
        computed: {
            imageStyle(): { '--image': string } {
                return {
                    '--image': `url(${NavigationProvider.getPersonImageUrl(this.value)})`
                }
            },
            showOtherPersons(): boolean {
                return this.persons.length > 1;
            },
            showTitle(): boolean {
                return !!MetadataProvider.getFieldByName(FieldName.PersonTitle) && !!this.value.PersonTitle;
            },
            showEmail(): boolean {
                return !!MetadataProvider.getFieldByName(FieldName.PersonEmail) && !!this.value.PersonEmail;
            },
            showEmail2(): boolean {
                return !!MetadataProvider.getFieldByName(FieldName.PersonEmail2) && !!this.value.PersonEmail2;
            },
            showDirectPhone(): boolean {
                return !!MetadataProvider.getFieldByName(FieldName.PersonDirectPhone) && !!this.value.PersonDirectPhone;
            },
            showMobilePhone(): boolean {
                return !!MetadataProvider.getFieldByName(FieldName.PersonMobilePhone) && !!this.value.PersonMobilePhone;
            },
        },
        methods: {
            open() {
                NavigationProvider.go(NavigationProvider.getPersonUrl(this.value.PersonId));
            },
            openDirectPhone() {
                NavigationProvider.go(`tel:${this.value.PersonDirectPhone}`);
            },
            openMobilePhone() {
                NavigationProvider.go(`tel:${this.value.PersonMobilePhone}`);
            },
            openEmail() {
                NavigationProvider.goEmail(this.value.PersonEmail, this.value.PersonName);
            },
            openEmai2l() {
                NavigationProvider.goEmail(this.value.PersonEmail2, this.value.PersonName);
            },
            selectPerson(person: Person) {
                this.$emit('input', person);
            },
        }
    });

</script>

<style scoped lang="scss">

</style>